import styled from '@emotion/styled/macro'
import { Flex } from '@rebass/grid/emotion'
import { Marked } from 'marked-ts'
import * as React from 'react'
import sanitizeHtml from 'sanitize-html'

const MarkdownViewContainer = styled(Flex)`
  blockquote {
    margin-left: 0;
    padding: 0 1em;
    color: #777;
    border-left: 0.25em solid #ddd;
  }
  ol {
    list-style-type: decimal;
    padding-left: 2em;
  }
  ul {
    list-style-type: disc;
    padding-left: 2em;
  }
  p {
    margin-top: 0;
    margin-bottom: 16px;
  }
  h1,
  h2,
  h3,
  h4 {
    line-height: 1.25;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.3em;
    margin-bottom: 16px;
  }
  code {
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 0.2em 0 0.2em 0;
    font-size: 90%;
  }
`

export const MarkdownView: React.FC<{ markdown: string | null }> = ({
  markdown,
}) => {
  Marked.setOptions({
    smartLists: true,
    tables: true,
    breaks: true,
    sanitize: true,
    sanitizer: sanitizeHtml,
  })

  const html = Marked.parse(markdown || '')

  return (
    <MarkdownViewContainer>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </MarkdownViewContainer>
  )
}
